import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Modal, { ModalBody, ModalFooter } from "./Modal";

export default function CountdownDialog({ message, seconds = 3, onComplete, onCancel }) {
  const { t } = useTranslation();
  const [remaining, setRemaining] = useState(seconds);
  const onCompleteRef = useRef(onComplete);
  onCompleteRef.current = onComplete;

  useEffect(() => {
    if (remaining <= 0) {
      onCompleteRef.current();
      return;
    }
    const timer = setTimeout(() => setRemaining((r) => r - 1), 1000);
    return () => clearTimeout(timer);
  }, [remaining]);

  return (
    <Modal>
      <ModalBody>
        <div className="text-center py-3">
          <div className="fs-1 fw-bold text-theme mb-3">{remaining}</div>
          <p className="mb-0">{message}</p>
        </div>
      </ModalBody>
      <ModalFooter>
        <button type="button" className="btn btn-default" onClick={onCancel}>
          {t("common.cancel")}
        </button>
      </ModalFooter>
    </Modal>
  );
}

CountdownDialog.propTypes = {
  message: PropTypes.string.isRequired,
  seconds: PropTypes.number,
  onComplete: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
